import {
    type ParentDocumentCanCreateFromRest,
    type ParentDocumentCanCreateForApollo,
} from './parent-document-can-create';
import {type RestTypeWithTypename} from '../rest-type-with-typename';

export const parentDocumentCanCreateTypePatcher = (
    data: ParentDocumentCanCreateFromRest,
): RestTypeWithTypename<ParentDocumentCanCreateForApollo> => {
    return {
        __typename: 'ParentDocumentCanCreate',
        ...data,
    };
};
